import { render, staticRenderFns } from "./response-information.vue?vue&type=template&id=70a1bd65"
import script from "./response-information.vue?vue&type=script&lang=js"
export * from "./response-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports